var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "243.74 95.99 243.74 104.11 228.31 104.11 228.31 119.49 243.74 119.49 243.74 127.61 265.67 111.8 243.74 95.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.82,56.48c-37.84,0-68.52,30.68-68.52,68.52s30.68,68.52,68.52,68.52,68.52-30.68,68.52-68.52-30.68-68.52-68.52-68.52Zm15.14,107.95l-14.22-26.45h-15.43v26.45h-20.62v-78.86h43.62c18.82,0,29.18,9.35,29.18,26.25,0,13.74-6.87,22.42-19.49,25.12l8.45,9.01,13.07,18.48h-24.56Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.9,103.11c13.54,0,21.81,8.27,21.81,21.62v29.42h-14.85v-28.86c0-5.36-2.54-8.37-6.96-8.37s-6.96,3.01-6.96,8.37v28.86h-14.85v-29.42c0-13.35,8.27-21.62,21.81-21.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m397.03,154.15v-58.47h14.23v58.47h-14.23Zm4.12-46.44v-12.03h35.09v12.03h-35.09Zm4.07,26.08v-12.03h30.33v12.03h-30.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m460.45,154.15h-14.37v-58.47h14.37v58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m492.16,95.63l15.83,42.92h.64l-.64-24.71v-18.21h13.63v58.52h-19.17l-16.43-43.88h-.6l.64,25.26v18.62h-13.63v-58.52h19.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m547.93,154.15h-14.37v-58.47h14.37v58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m556.99,107.62v-11.94h46.58v11.94h-46.58Zm16.15,46.53v-55.73h14.32v55.73h-14.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m626.99,154.15h-14.37v-58.47h14.37v58.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.67da969af6715e0611b1099cceacc9d8.svg";
export { ForwardRef as ReactComponent };